export class UdfOptions {
  displayText: 'Passed Technical Review';
  udfId: 'ConditionallyApprovedReason';
  value: 'PassedTechnicalReview';
}
